import { defineStore } from 'pinia';
export const useHeaderStore = defineStore('useHeaderStore', {
    state() {
        return {
            currentCarModelInfo: {},
        };
    },
    getters: {
        currentCarLogo() {
            return this.currentCarModelInfo?.model_logo_url;
        },
    },
    actions: {
        setCarModelInfo(carInfo) {
            console.log('---carInfo---', carInfo);
            this.currentCarModelInfo = carInfo;
        },
    },
});
